import {find, getDebug} from "./functions"
import customPowermail from "./components/custom-powermail"
import passwordHandling from "./components/felogin/show-pass"

document.addEventListener("DOMContentLoaded", function () {
    let debug = getDebug()
    setTimeout(function () {
        if (find(".tx-powermail.custom-design .powermail_form_3")) {
            let cPM = new customPowermail()
            window.customPowermail = cPM
        }
    }, 250)

    /* editAdress */
    try {
        let forms = document.querySelectorAll(".editAddress.standard-form > .address-edit-form")
        forms.forEach(function (form) {
            if (form) {
                let formId = form.getAttribute("id")
                if (formId) {
                    let int = formId.split("-")[1]
                    let button = document.querySelector("#AFT-" + int)
                    let newButton = document.querySelector(".info .newAdress")
                    let container = document.querySelector("#AFC-" + int)
                    container.classList.add("hidden")
                    let stop = document.querySelectorAll(".editAdress .form-controls .btn-secondary")
                    stop.forEach(function (el) {
                        el.addEventListener("click", function (e) {
                            container.classList.add("hidden")
                            newButton.classList.remove("hidden")
                            button.classList.remove("display")
                        })
                    })
                    /* toggle display */
                    button.addEventListener("click", function (e) {
                        var openend = document.querySelectorAll(".editAddress .form-container")
                        if (openend) {
                            openend.forEach(function (el) {
                                if (!el.classList.contains("hidden")) {
                                    el.classList.add("hidden")
                                }
                            })
                        }
                        if (container.classList.contains("hidden")) {
                            container.classList.remove("hidden")
                            newButton.classList.add("hidden")
                            button.classList.add("display")
                            button.scrollIntoView({behavior: "smooth", block: "start"})
                        } else {
                            container.classList.add("hidden")
                            newButton.classList.remove("hidden")
                            button.classList.remove("display")
                        }
                    })
                }
            }
        })
    } catch (error) {
        // console.log("Error in editAdress script: ", error)
    }
    /* FE User Status */

    /* Sweet Alert */
    let Swal = require("sweetalert2")
    let location = window.location.pathname.split("/")
    /* if user is not logged in and is on the "Abholung" site */
    if (location[location.length - 1] === "abholung" && window.FE_USER_LOGGED_IN == false) {
        Swal.fire({
            title: "Bitte loggen Sie sich ein.",
            text: "Um eine Abholung anzumelden müssen Sie sich einloggen.",
            icon: "warning",
            confirmButtonText: "Ok",
            showCancelButton: false,
        }).then((result) => {
            window.location.href = "/"
        })
    }
    /* popup if user password is still not set to new configuration */
    if (document.querySelector("#password-needed")) {
        let needed = document.querySelector("#password-needed").getAttribute("data-password-needed");
            if(needed == 1) {
                Swal.fire({
                    title: "Passwortänderung erforderlich",
                    html: "Zum Schutz Ihrer Daten wurde unser Login-System am 23. Juli 2025 umgestellt.<br/><b>Sie nutzen noch Ihr Standardpasswort.</b><br/>Bitte vergeben Sie jetzt ein <b>neues, sicheres Passwort</b> – Sie werden nach dem Login automatisch dazu aufgefordert.<br/><br/> Danke für Ihre Mithilfe!",
                    icon: "info",
                    confirmButtonText: "Passwort setzen",
                    showCancelButton: true,
                    cancelButtonText: "Später",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = "/renewpassword"
                    } else {
                        // do nothing, user can continue without setting password - at least for now
                    }
                })
            }

        // console.log("Password change needed: ", needed);
    }
    /* Password Show/Hide */
    new passwordHandling()
})
